import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Breadcrumbs, RouteLayout } from '@web/app/components'

export const Route = createFileRoute('/_index/cuenta')({
  component: RouteComponent,
  staticData: {
    metaRoute: {
      title: 'Cuenta',
      hidden: true,
    },
  },
})

function RouteComponent() {
  return (
    <RouteLayout>
      <Breadcrumbs basePath={Route.fullPath} fd={'row'} ai={'center'} gap={'$1'} mb={'$true'} />
      <Outlet />
    </RouteLayout>
  )
}
